import { chainColor } from "../lib/format.ts";

export function ChainBadge({ chain, className = "" }: { chain: string; className?: string }) {
	const c = chainColor(chain);
	return (
		<span
			className={`inline-flex items-center rounded-pill px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${className}`}
			style={{ background: c.bg, color: c.fg }}
		>
			{chain}
		</span>
	);
}
